import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { fg } from '@confluence/feature-gating';

export const useSmartButtonPremiumGate = (): {
	isSmartButtonAllowed: boolean;
} => {
	const { edition } = useSessionData();

	const isPremium = edition === ConfluenceEdition.PREMIUM;

	return {
		isSmartButtonAllowed: isPremium || fg('a4c_free_and_standard_editions'),
	};
};
